import { useQuery, useQueryClient, } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { API_INBOXES_PATH } from 'src/services/api/inboxes/constants';
import { type IInbox } from 'src/services/api/inboxes/types';
import { omitNullsFromInboxFilter } from 'src/pages/landlord/conversations/utils/filter-conversations';

type IInboxResponse = {
    inboxes: IInbox[]
}

/**
 * Fetches inboxes from the API server only.
 * To use all inboxes including virtual inboxes (Team Inbox, My Tasks), use the use-all-inboxes hook.
 */
export const useInboxes = () => {
    const queryClient = useQueryClient();

    return useQuery([queryKeys.inboxes], async () => {
        const res = await apiClient(API_INBOXES_PATH).json<IInboxResponse>();
        const inboxes = res.inboxes;
        // correct some issues that may come from the backend
        inboxes.forEach((inbox) => {
            if (inbox.filters) {
                inbox.filters = omitNullsFromInboxFilter(inbox.filters);
            }

        });
        return inboxes;
    }, {
        keepPreviousData: true,
        onSuccess: (views) => {
            for (const view of views) {
                queryClient.setQueryData([queryKeys.inboxes, view.id], view);
            }
        }
    });
};
